import { UserAccessRightService } from './../../../shared/services/user-access-rights.service'

import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'

import { Observable, of, Subject } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'

import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Store } from '@ngrx/store'

import { Raffle } from '../raffle'
import { raffleActions } from '../raffle.actions'
import { raffleSelectors } from '../raffle.selectors'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

import {
  CondOperator,
  QuerySortOperator,
  RequestQueryBuilder
} from '@nestjsx/crud-request'
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  take,
  timeout,
  withLatestFrom
} from 'rxjs/operators'
import {
  AccessRights,
  UserRole
} from 'src/app/features/role/user-role/user-role'
import DEBOUNCED_TIME = Constants.DEBOUNCED_TIME
import { Constants } from 'src/app/shared/constants'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import moment from 'moment-mini'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { courseSelectors } from '../../course/course.selectors'
import { RaffleService } from '../raffle.service'
import { BsModalService } from 'ngx-bootstrap/modal'
import { environment } from 'src/environments/environment'
import { GenericMainWrapperModalComponent } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal.component'
import { getNavItems } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal-utils'
import { NavItemType } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal-constants'

@UntilDestroy()
@Component({
  selector: 'raffles-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class RaffleIndexComponent implements OnInit {
  // public raffles$: Observable<Raffle[]>
  public raffles$: Subject<Raffle[]> = new Subject<Raffle[]>()
  public selectedType: string = 'all'
  public selectedUserRole$: Observable<UserRole>
  public accessRights = AccessRights
  public total: number = 0
  public page: number = 1
  public limit: number = 25
  public pageCount: number = 0
  public form: UntypedFormGroup
  public key
  public subKey
  private sortField = 'closeDate'
  public sortOrder = 'DESC'
  public removeSearchTerm$: Subject<boolean> = new Subject<boolean>()
  public searchTerm$ = new Subject<string>()
  public searchTerm
  public raffleModuleConfig = environment.moduleConfigs.raffleModule
  private URL_BASE = '/raffles'
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private actions$: Actions,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    public userAccessRightService: UserAccessRightService,
    public notificationService: NotificationService,
    private raffleService: RaffleService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    const navigationEntries = performance.getEntriesByType(
      'navigation'
    ) as PerformanceNavigationTiming[]
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === 'back_forward' &&
      navigationEntries[0].name.includes('(modal:') &&
      this.route.outlet == 'primary'
    ) {
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
    }
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === 'reload'
    ) {
      //hard Refresh
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
    }
    this.form = this.fb.group({
      isActive: [true, []],
      selectedType: ['all', []]
    })
    this.fetchActiveRaffles()

    this.searchTerm$
      .pipe(distinctUntilChanged(), debounceTime(5), untilDestroyed(this))
      .subscribe((term) => {
        this.searchTerm = term
        this.page = 1
        if (
          this.form.controls.selectedType.value == 'all' &&
          this.form.controls.isActive.value == true
        ) {
          this.fetchActiveRaffles()
        } else if (
          this.form.controls.selectedType.value == 'all' &&
          this.form.controls.isActive.value == false
        ) {
          this.fetchInactiveRaffles()
        }
      })
    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((tab) => {
      this.removeSearchTerm$.next(true)
      this.searchTerm = null
      this.page = 1
      this.raffles$.next([])
      this.total = 0
      this.pageCount = 0
      this.selectedType = this.form.controls.selectedType.value
      if (
        this.form.controls.selectedType.value == 'all' &&
        this.form.controls.isActive.value == true
      ) {
        this.fetchActiveRaffles()
      } else if (
        this.form.controls.selectedType.value == 'all' &&
        this.form.controls.isActive.value == false
      ) {
        this.fetchInactiveRaffles()
      }
    })
    this.form.controls.isActive.patchValue(true)
    this.actions$
      .pipe(
        untilDestroyed(this),
        ofType(raffleActions.upsertMany),
        withLatestFrom(this.store.select(courseSelectors.selectEntities)),
        catchError((error) => of(null))
      )
      .subscribe(([action, courseEntitites]) => {
        if (!action) {
          return
        }
        if (this.router.url != this.URL_BASE) return
        this.total = action?.total
        this.pageCount = action?.pageCount
        let raffles = JSON.parse(JSON.stringify(action?.entities))
        for (const raffle of raffles) {
          if (raffle.courseId) {
            raffle.course = courseEntitites[raffle.courseId]
          }
        }
        this.key = this.sortField

        this.raffles$.next(raffles)
      })
    this.store.dispatch(
      BreadCrumbActions.initHistory({
        pageName: 'raffleModule.raffles',
        url: '/raffles',
        titleName: ['raffleModule.raffles']
      })
    )
  }
  public onClickSelectedType(type: string) {
    if (this.selectedType !== type) {
      this.searchTerm = null
      this.limit = 25
      this.page = 1
      this.removeSearchTerm$.next(true)
    }
    this.selectedType = type
    this.form.controls.selectedType.patchValue(type)
  }

  private fetchRaffles() {
    if (!this.searchTerm) {
      this.store.dispatch(
        raffleActions.fetchMany({
          params: RequestQueryBuilder.create({
            page: this.page,
            limit: this.limit,
            join: [{ field: 'course' }],
            sort: {
              field: this.sortField,
              order: this.sortOrder.toUpperCase() as QuerySortOperator
            }
          })
        })
      )
    } else {
      this.store.dispatch(
        raffleActions.fetchMany({
          params: RequestQueryBuilder.create({
            page: this.page,
            limit: this.limit,
            search: {
              'course.description': {
                [CondOperator.CONTAINS_LOW]: this.searchTerm
              }
            },
            join: [{ field: 'course' }],
            sort: {
              field: this.sortField,
              order: this.sortOrder.toUpperCase() as QuerySortOperator
            }
          })
        })
      )
    }
  }
  private fetchInactiveRaffles() {
    if (!this.searchTerm) {
      this.store.dispatch(
        raffleActions.fetchMany({
          params: RequestQueryBuilder.create({
            page: this.page,
            limit: this.limit,
            search: {
              $or: [
                {
                  closeDate: {
                    [CondOperator.LOWER_THAN]: moment().format('YYYY-MM-DD')
                  }
                },
                {
                  closeDate: {
                    [CondOperator.IS_NULL]: true
                  }
                }
              ]
            },

            join: [{ field: 'course' }],
            sort: {
              field: this.sortField,
              order: this.sortOrder.toUpperCase() as QuerySortOperator
            }
          })
        })
      )
    } else {
      this.store.dispatch(
        raffleActions.fetchMany({
          params: RequestQueryBuilder.create({
            page: this.page,
            limit: this.limit,
            search: {
              $or: [
                {
                  closeDate: {
                    [CondOperator.LOWER_THAN]: moment().format('YYYY-MM-DD')
                  }
                },
                {
                  closeDate: {
                    [CondOperator.IS_NULL]: true
                  }
                }
              ],
              'course.description': {
                [CondOperator.CONTAINS_LOW]: this.searchTerm
              }
            },
            join: [{ field: 'course' }],
            sort: {
              field: this.sortField,
              order: this.sortOrder.toUpperCase() as QuerySortOperator
            }
          })
        })
      )
    }
  }
  private fetchActiveRaffles() {
    if (!this.searchTerm) {
      this.store.dispatch(
        raffleActions.fetchMany({
          params: RequestQueryBuilder.create({
            page: this.page,
            limit: this.limit,
            search: {
              closeDate: {
                [CondOperator.GREATER_THAN_EQUALS]:
                  moment().format('YYYY-MM-DD')
              }
            },

            join: [{ field: 'course' }],
            sort: {
              field: this.sortField,
              order: this.sortOrder.toUpperCase() as QuerySortOperator
            }
          })
        })
      )
    } else {
      this.store.dispatch(
        raffleActions.fetchMany({
          params: RequestQueryBuilder.create({
            page: this.page,
            limit: this.limit,
            search: {
              closeDate: {
                [CondOperator.GREATER_THAN_EQUALS]:
                  moment().format('YYYY-MM-DD')
              },
              'course.description': {
                [CondOperator.CONTAINS_LOW]: this.searchTerm
              }
            },
            join: [{ field: 'course' }],
            sort: {
              field: this.sortField,
              order: this.sortOrder.toUpperCase() as QuerySortOperator
            }
          })
        })
      )
    }
  }
  public onClickRow(raffle: Raffle) {
    this.raffleService.showModal = true
    const modalRef = this.modalService.show(GenericMainWrapperModalComponent, {
      initialState: {
        navItems: getNavItems(
          String(raffle.id),
          {
            fullAccess: this.raffleModuleConfig.isActive,
            isActive: this.raffleModuleConfig.isActive
          },
          NavItemType.RAFFLE
        ),
        actions: raffleActions,
        entity: raffle,
        selectIdRouteParam$: this.store.select(
          raffleSelectors.selectIdRouteParam
        ),
        moduleConfigIsActive: this.raffleModuleConfig.isActive,
        entities$: this.store.select(raffleSelectors.selectEntities),
        modalRoute: 'modal-raffle',
        service: this.raffleService,
        type: NavItemType.RAFFLE,
        ariaLabelKey: 'wcag.raffleMenu'
      },
      class: 'modal-lg modal-dialog-scrollable modal-dialog-centered'
    })
    modalRef.onHide.pipe(take(1)).subscribe((modal) => {
      this.raffleService.showModal = false
    })
  }

  public onClickCreate() {
    this.router.navigate(['/raffles/create'])
  }

  public isAllowedByAccessRights(accessRight: string) {
    this.userAccessRightService.isAllowedByAccessRight([
      AccessRights[accessRight]
    ])
  }
  public selectNewPage(page) {
    this.page = page
    if (
      this.form.controls.selectedType.value == 'all' &&
      this.form.controls.isActive.value == true
    ) {
      this.fetchActiveRaffles()
    } else if (
      this.form.controls.selectedType.value == 'all' &&
      this.form.controls.isActive.value == false
    ) {
      this.fetchInactiveRaffles()
    }
  }
  public onSortedTable(sortTerms) {
    this.sortField = sortTerms.split('_')[0]
    if (this.sortField == 'courseId') {
      this.sortField = 'course.description'
    }
    this.sortOrder = sortTerms.split('_')[1]
    this.page = 1
    if (
      this.form.controls.selectedType.value == 'all' &&
      this.form.controls.isActive.value == true
    ) {
      this.fetchActiveRaffles()
    } else if (
      this.form.controls.selectedType.value == 'all' &&
      this.form.controls.isActive.value == false
    ) {
      this.fetchInactiveRaffles()
    }
  }
  public selectNewLimit(limit) {
    this.limit = limit
    this.page = 1
    if (
      this.form.controls.selectedType.value == 'all' &&
      this.form.controls.isActive.value == true
    ) {
      this.fetchActiveRaffles()
    } else if (
      this.form.controls.selectedType.value == 'all' &&
      this.form.controls.isActive.value == false
    ) {
      this.fetchInactiveRaffles()
    }
  }
  public onSearchTerm(searchTerm) {
    if (searchTerm.length > 0) {
      this.searchTerm$.next(searchTerm)
    } else {
      this.searchTerm = null
      this.page = 1
      if (
        this.form.controls.selectedType.value == 'all' &&
        this.form.controls.isActive.value == true
      ) {
        this.fetchActiveRaffles()
      } else if (
        this.form.controls.selectedType.value == 'all' &&
        this.form.controls.isActive.value == false
      ) {
        this.fetchInactiveRaffles()
      }
    }
  }
  public onBulkAction(bulkActionEvent: BulkActionEvent) {
    if (bulkActionEvent.action == BulkAction.DELETE) {
      bulkActionEvent.items.forEach((i) =>
        this.store.dispatch(raffleActions.deleteOne({ id: i.id }))
      )

      this.actions$
        .pipe(
          ofType(raffleActions.removeOne),
          take(bulkActionEvent.items.length),
          timeout(5000),
          catchError((error) => of(null))
        )
        .subscribe((action) => {
          action
            ? this.notificationService.emit('alerts.success', 'success')
            : null
        })
    }
  }
}
